import type { common as partnerRegisterCommon } from '#proto/index.qonto.registration.partner_register';
import { firstparty as registerPartnerRegistration } from '#proto/index.qonto.registration.register.partner_registrations';
import type {
  JSONApiDataEntity,
  RelationshipData,
  ToOneRelationshipData,
} from '../../src/types/json-api';

export { ApiGetPartnerRegistrationResponse } from '#proto/index.qonto.registration.register.partner_registrations.firstparty.v1';

export type ApiRegistration = partnerRegisterCommon.v1.ApiRegistration;
export type ApiOrganization = partnerRegisterCommon.v1.ApiOrganization;
export type ApiStakeholder = partnerRegisterCommon.v1.ApiStakeholder;
export type ApiPartnerRegistration = registerPartnerRegistration.v1.ApiPartnerRegistration;

export const ApiPartnerRegistration = registerPartnerRegistration.v1.ApiPartnerRegistration;

interface RegistrationRelationships {
  organization: ToOneRelationshipData;
  stakeholders: RelationshipData;
}

type RegistrationEntity = JSONApiDataEntity<Record<string, unknown>, RegistrationRelationships> & {
  relationships: RegistrationRelationships;
};

export interface RegistrationJsonApiResponse {
  data: RegistrationEntity;
  included?: JSONApiDataEntity<Record<string, unknown>>[];
}

interface OrganizationRelationships {
  registration: ToOneRelationshipData;
}

export interface OrganizationsJsonApiResponse {
  data: JSONApiDataEntity<Record<string, unknown>, OrganizationRelationships>[];
  included?: JSONApiDataEntity<Record<string, unknown>>[];
}

export interface RegisterPartnersOrganizationsResult {
  organizations: ApiOrganization[];
  includedRegistrations: ApiRegistration[];
}

export interface RegisterPartnersRegistrationResult {
  registration: ApiRegistration;
  stakeholders: ApiStakeholder[];
  organization: ApiOrganization;
}

export interface PartnerRegistrationJsonApiResponse {
  data: {
    id: string;
    type: string;
    attributes: Record<string, unknown>;
  };
}
